module.exports = __webpack_public_path__ + "static/media/cardblank.7de7043e.png";